import { constrainLength } from "../utils/form";
import plusIcon from "../images/plus.svg";
import styles from "../css/SetupForm.module.css";
import { useEffect, useState } from "react";
import { openDB } from "idb";

const MAX_CHARS = {
  copies: 2,
  kot_heading: 20,
};
// const MESSAGE_LINES = {};

export default function KotPrinterSetupFormGroup({
  printerSetup,
  setPrinterSetup,
  setPageConfigrationSetup,
  printers,
}) {
  const [group, setGroup] = useState([]);

  useEffect(() => {
    const getData = async () => {
      let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);

      let tx = db.transaction("item_grouping", "readwrite");
      let store = tx.objectStore("item_grouping");
      let getReq = await store.getAll();

      setGroup(getReq);
    };
    getData();
  }, []);

  const addPrinter = () => {
    setPrinterSetup([
      ...printerSetup,
      {
        printer_name: "0",
        copies: "",
        kot_heading: "",
        item_group_uuid: "",
      },
    ]);
  };

  // console.log("printersetup", printerSetup);

  const handleChange = (event, printer) => {
    const getValue = (e) => (e.type === "checkbox" ? e.checked : e.value);
    const getSelectedValues = (e) =>
      [...e.options].filter((e) => e.selected).map((e) => e.value);

    const value = event.target.multiple
      ? getSelectedValues(event.target)
      : getValue(event.target);

    const name = event.target.name;
    const isNumber = Object.keys(MAX_CHARS).includes(name);
    const constrainedValue = isNumber
      ? constrainLength(String(value), MAX_CHARS[name])
      : value;

    setPrinterSetup([
      ...printerSetup.map((item, i) => {
        if (item._id === printer._id) {
          return { ...item, [event.target.name]: constrainedValue };
        } else {
          return item;
        }
      }),
    ]);
  };

  return (
    <div className={styles.formGroup}>
      <h2>Printer Setup</h2>

      {printerSetup?.map((printer, index) => (
        <div className={styles.row} key={index}>
          {printerSetup.length !== 1 && (
            <button
              type='button'
              className={styles.deleteBtn}
              onClick={() =>
                setPrinterSetup(printerSetup.filter((item, i) => i !== index))
              }>
              X
            </button>
          )}
          <label className={styles.selectLabel} style={{ width: "20%" }}>
            Select printer
            <select
              name='printer_name'
              className={styles.select}
              style={{ width: "100%" }}
              onChange={(e) =>
                setPrinterSetup([
                  ...printerSetup.map((item, i) => {
                    if (item._id === printer._id) {
                      return { ...item, printer_name: e.target.value };
                    } else {
                      return item;
                    }
                  }),
                ])
              }
              value={printer?.printer_name}>
              {+printer?.printer_name === 0 || printer?.printer_name === "" ? (
                <option value='0'>Browser Printer</option>
              ) : (
                <>
                  <option value={printer?.printer_name} selected>
                    {printer?.printer_name}
                  </option>
                  <option value='0'>Browser Printer</option>
                </>
              )}

              {printers
                ?.filter((a) => a.name !== printer.printer_name)
                ?.map((item) => (
                  <option key={item.deviceId} value={item.deviceId}>
                    {item.name}
                  </option>
                ))}
              {printers?.map((item) => (
                <option key={item.deviceId} value={item.deviceId}>
                  {item.name}
                </option>
              ))}
            </select>
          </label>

          <label className={styles.selectLabel} style={{ width: "12%" }}>
            No. of copies
            <input
              type='number'
              name='copies'
              className={styles.numberInput}
              style={{ width: "100%" }}
              value={printer?.copies}
              onChange={(e) => handleChange(e, printer)}
            />
          </label>

          <label className={styles.selectLabel} style={{ width: "15%" }}>
            KOT Heading
            <input
              type='text'
              name='kot_heading'
              className={styles.numberInput}
              style={{ width: "100%" }}
              value={printer?.kot_heading}
              onChange={(e) => handleChange(e, printer)}
            />
          </label>

          <label className={styles.selectLabel} style={{ width: "18%" }}>
            Select Item Group
            <select
              name='item_group_uuid'
              className={styles.select}
              style={{ width: "100%" }}
              value={printer?.item_group_uuid}
              onChange={(e) =>
                setPrinterSetup([
                  ...printerSetup.map((item, i) => {
                    if (item._id === printer._id) {
                      return { ...item, item_group_uuid: e.target.value };
                    } else {
                      return item;
                    }
                  }),
                ])
              }>
              <option value='all' selected>
                All
              </option>
              {group &&
                group?.map((item) => (
                  <option
                    key={item.item_group_uuid}
                    value={item.item_group_uuid}>
                    {item.item_group_title}
                  </option>
                ))}
            </select>
          </label>

          <button
            type='button'
            className={styles.fieldCustomizationButton}
            onClick={() => setPageConfigrationSetup(index + 1)}>
            Page Configuration
          </button>
        </div>
      ))}

      <button
        className={styles.addMealButton}
        onClick={addPrinter}
        type='button'>
        <img src={plusIcon} alt='plus' />
      </button>
    </div>
  );
}
